import Administer from './administer-container'
export default Administer
